export const EDIT_MODAL_CONTROL_TYPE = {
  BUTTON: 'button',
  LINK: 'link',
};
